import httpClient from './httpClient';

const ps_orders = (parameter) => httpClient.post('/api/ps_order',parameter);
const ps_order_search = (querySearch) => httpClient.get('/api/ps_order/search/'+querySearch);
const update_ps_order = (order) => httpClient.put('/api/ps_order/'+order.id_order, order);
const status_tracking_ps_order = (form) => httpClient.post('/api/ps_order/update_status_tracking/',form);
const status_sms_ps_order = (reference) => httpClient.post('/api/ps_order/update_status_sms/',reference);
const product_review_request_ps_order = (form) => httpClient.post('/api/ps_order/product_review_request/', form);

export {
    ps_orders,
    ps_order_search,
    update_ps_order,
    status_tracking_ps_order,
    status_sms_ps_order,
    product_review_request_ps_order
}
